import React, { useState } from "react";
import "./Excellence.css";

const Excellence = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <div className="excellence-container">
      <video
        className="excellence-video"
        autoPlay
        muted
        loop
        playsInline
        poster="/images/homebg.png"
      >
        <source
          src="/video/enroll.mp4"
          type="video/mp4"
        />
      </video>

      <div className="excellence-overlay"></div>

      <div className="excellence-left">
        <div className="excellence-content excellence-left-content">
          <h4>Step into the Future of</h4>
             <h3>Education.</h3>
          
          <button
            className="excellence-left-btn"
            onClick={() => setIsVideoOpen(true)}
          >
            Take a tour
          </button>
        </div>
      </div>

      {isVideoOpen && (
        <div className="video-modal" onClick={() => setIsVideoOpen(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="video-modal-close"
              onClick={() => setIsVideoOpen(false)}
              aria-label="Close video"
            >
              ×
            </button>
            <video className="video-modal-player" controls autoPlay>
              <source src="/video/enroll.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      )}

      <div className="excellence-right">
        <div className="excellence-content">
          <h4>Begin Your Journey Toward</h4>
          <h3>Excellence.</h3>

          <button className="excellence-btn">
            Enroll for a Better Future
          </button>
        </div>
      </div>
    </div>
  );
};

export default Excellence;
